import styled from "@emotion/styled";

import { fontRoboto, fontRobotoCondensed } from "shared/lib/styles";

import Background from "./background.png";
import Logo from "./logo.svg";

export const StyledLogo = styled(Logo)``;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
`;

export const Content = styled.div`
  display: inline;
  flex: 1;

  color: #ffffff;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  line-height: 19px;
`;

export const HighlightedContent = styled(Content)`
  color: #8ab2ff;
  font-weight: 700;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;

  inline-size: 200px;
`;

export const StyledButton = styled.button`
  inline-size: 100%;
  padding-block: 8px;
  padding-inline: 12px;

  color: #ffffff;
  font-weight: 700;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  line-height: 20.8px;
  white-space: nowrap;

  border: 2px solid #4585ff;
  border-radius: 2px;

  background: #4585ff;

  cursor: pointer;
`;

export const LoginWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 6px;
  justify-content: center;
`;

export const LoginMessage = styled.div`
  display: inline;

  color: #ffffff;
  font-size: 12px;
  font-family: ${fontRoboto};
  line-height: 12px;
`;

export const LoginText = styled.div`
  display: inline;

  color: #4585ff;
  font-weight: 700;
  font-size: 12px;
  font-family: ${fontRoboto};
  line-height: 12px;

  cursor: pointer;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  block-size: 183px;
  padding: 20px;

  border-radius: 8px;

  background: #4585ff;
  background-image: url(${Background.src});
  background-position: top right;
  background-size: cover;

  outline: 1px solid #cccccc;
`;
